<script>
    import CreateMediaDownloadPackage from '../../../../Packages/resources/js/components/CreateMediaDownloadPackage.vue'
    import { modelToolHelpers } from '../../mixins/model-tool-helpers'

    export default {
        mixins: [
            modelToolHelpers('ScoopModelSelectorToolsDownloadMedia')
        ],
        components: {
            'create-media-download-package': CreateMediaDownloadPackage
        },
        data() {
            return {
                downloadStep: null, // null = not yet opened, 1 = step1, etc.
            }
        },
        computed: {
            mediaSelected: {
                get: function () {
                    return scoopOS.getSelected('medias');
                },
                set: function (newValue) {
                    scoopOS.replaceAll('medias', newValue);
                }
            },
            count() {
                return this.mediaSelected.length;
            },
            isVisible() {
                return this.allowedToSee();
            },
        },
        methods: {
        },
    }
</script>

<template>
    <a id="download-media-icon" class="count-info"  @click="downloadStep = 1" v-if="isVisible">
        <span class="download-info">
        <portal to="modals">
            <create-media-download-package
                :selected-media="mediaSelected"
                :step="downloadStep"
                @close="downloadStep = null"
            >
            </create-media-download-package>
        </portal>

         <i class="fa fa-download"></i>Download
        </span>
    </a>
</template>
